/** Same-origin in production; backend on :3001 only for local dev. */
export function resolveApiBaseUrl() {
  if (process.env.REACT_APP_BLOG_API_URL?.trim()) {
    return process.env.REACT_APP_BLOG_API_URL.trim().replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    if (port === '3000' || hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${protocol}//${hostname}:3001`;
    }
  }
  return '';
}

export function resolveUploadUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  if (!path.startsWith('/uploads/')) return path;
  const base = resolveApiBaseUrl();
  return base ? `${base}${path}` : path;
}
